module.exports = __webpack_public_path__ + "media/img/seed/1-4be496070b438975ba4c23da50b6047b.jpeg";